import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

export const useAnnouncements = () => {
  const { getAuthHeaders } = useContext(AuthContext);
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const headers = getAuthHeaders();
        const res = await fetch('/api/announcements', { headers });
        const data = await res.json();
        if (data.success) {
          setAnnouncements(data.announcements);
        } else {
          setError(data.error || 'Failed to load announcements');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchAnnouncements();
  }, [getAuthHeaders]);

  return { announcements, loading, error };
};
